import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Spin } from 'antd'
import MainLayout from 'components/mainLayout'
import useDemandDetails from 'pages/detailsDemands/hooks/useDemandDetails'

export default function WithDemandDetails(WrappedComponent) {
	const WithDetailsComponent = (props) => {
		const { id } = useParams()
		const history = useHistory()
		const { data, isLoading, isError, refetch } = useDemandDetails(id)

		if (isLoading) {
			return (
				<MainLayout selectedKey="demands">
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '100%',
							width: '100%',
						}}>
						<Spin size="large" />
					</div>
				</MainLayout>
			)
		}

		if (isError) {
			return (
				<MainLayout selectedKey="demands">
					<div>
						Não foi possível carregar os dados. Tente novamente mais tarde.
					</div>
				</MainLayout>
			)
		}

		if (!data) {
			return (
				<MainLayout selectedKey="demands">
					<div>Demanda não encontrada. Retorne à lista de demandas.</div>
				</MainLayout>
			)
		}

		return (
			<WrappedComponent
				{...props}
				id={id}
				history={history}
				data={data}
				refetch={refetch}
			/>
		)
	}

	return WithDetailsComponent
}
